import { appLogger } from '@/utils/logger';
import { type BoundaryProps, ErrorBoundary } from './ErrorBoundary';

export const ErrorBoundarySpaces = (props: BoundaryProps) => (
  <ErrorBoundary
    {...props}
    errorMessage="Error loading spaces"
    onRetry={() => {
      appLogger.error('Space component removed due to an error.');
    }}
  />
);
